<template>
  <div class="container" v-if="loading">
    <div class="loader"></div>
  </div>
  <div v-else>
    <ConfigureAuthApp
      v-if="showConfigureApp"
      :qrdata="uriEnroll"
      @enrolled="onEnrolled"
      :secret="secret"
      :mfaToken="mfaToken"
      :state="state"
    ></ConfigureAuthApp>
    <ShowRecoveryCode v-if="showRecoveryCodePage" :recovery-code="recoveryCode" :state="state"></ShowRecoveryCode>
  </div>
</template>

<script>
import ConfigureAuthApp from '../components/ConfigureAuthApp';
import ShowRecoveryCode from '../components/ShowRecoveryCode';

export default {
  name: 'EnrollAuthenticator',
  props: ['mfaToken', 'authenticatorList', 'state'],
  components: {
    ConfigureAuthApp,
    ShowRecoveryCode
  },
  data() {
    return {
      showConfigureApp: false,
      showRecoveryCodePage: false,
      loading: true,
      uriEnroll: null,
      secret: null,
      recoveryCode: null
    };
  },
  async mounted() {
    try {
      const response = await fetch(`${process.env.VUE_APP_API_URL}/users/v1/users/byID/me/mfa/enrollments`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.mfaToken}`
        },
        body: JSON.stringify({
          client_id: process.env.VUE_APP_AUTH0_CLIENT_ID,
          authenticator_types: ['otp']
        })
      });

      if (!response.ok) {
        throw new Error('Cannot enroll')
      }

      const otpEnroll = await response.json();

      this.uriEnroll = otpEnroll.barcode_uri;
      this.secret = otpEnroll.secret;
      this.recoveryCode = otpEnroll.recovery_codes[0];
      this.loading = false;
      this.showConfigureApp = true;
    } catch (e) {
      this.$toasted.show(e)
    }
  },
  methods: {
    onEnrolled() {
      this.showConfigureApp = false;
      this.showRecoveryCodePage = true;
    }
  }
};
</script>
